import { atom } from '@reatom/framework'

import { ProfileTab } from '../model/profile-tabs'

import type { Comment } from '@root/entities/comment'
import type { Period } from '@root/shared/period'

export const profileBoardAtom = atom<ProfileTab>(
  ProfileTab.Statistics,
  'profileBoardAtom',
)

export const profileCommentsTabAtom = atom<Comment.CommentType>(
  'comments',
  'profileCommentsTabAtom',
)
export const commentsPeriodAtom = atom<Period.Period>(
  'ALL',
  'commentsPeriodAtom',
)
